<template>
<v-card height="100%" dark color="darkBackground" style="overflow: hidden">
    <div v-if="title">
    <v-card-title style="background: white">
        <span style="color: black"> {{title}} <v-chip v-if="chip"
          color="info"
          dark
          small
        >
          {{chip}}
        </v-chip></span>
    </v-card-title>
        <slot name="header"></slot>
    <v-divider class="mx-4"></v-divider>
    </div>
    <v-card-text>
        <slot></slot>
    </v-card-text>
</v-card>
</template>


<script>
export default {
    name: 'ScrollableVueCardMultipleSlots',
    props:{
        title: String,
        chip: String
    },
    data: () => ({
    })
}
</script>
<style scoped> 

.v-card {
  display: flex !important;
  flex-direction: column;
}

.v-card__text {
  flex-grow: 1;
  overflow: auto;
  padding: 0;
}
</style>